import { SWReactIcons } from "@similarweb/icons";
import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";
import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";
import styled from "styled-components";
import { Marker } from "pro-features/components/Legends/src/LegendBase/Legend";
import { chosenItems } from "app/common/services/chosenItems";
import { AppTooltip } from "pro-features/components/tooltips/src/AppTooltip/AppTooltip";

export interface IAppHeaderWithMarkerProps extends ITableHeaderCellProps {
    color: string;
    isRightAligned?: boolean;
}

const HeaderWrapper = styled.span<{ isRightAligned?: boolean }>`
    flex-direction: ${({ isRightAligned }) => (isRightAligned ? "row-reverse" : "row")};
    display: flex;
    width: 100%;
    .u-flex-row {
        flex-direction: row;
        max-width: 100%;
    }
`;

const MarkerWrapper = styled.span`
    justify-content: center;
    display: flex;
    align-items: center;
`;

const AppHeaderWrapper = styled.span`
    display: flex;
    flex-direction: row;
    max-width: 100%;
`;

const SortComponent: FC<{ sortDirection: string }> = (props) => {
    const { sortDirection } = props;
    return (
        <div className="headerCell-sortDirection">
            {sortDirection.toUpperCase() === "DESC" ? (
                <SWReactIcons
                    iconName="arrow-down-grey"
                    size="xs"
                />
            ) : null}
            {sortDirection.toUpperCase() === "ASC" ? (
                <SWReactIcons
                    iconName="arrow-up-grey"
                    size="xs"
                />
            ) : null}
        </div>
    );
};

export const AppHeaderWithMarker: FC<IAppHeaderWithMarkerProps> = (props) => {
    const { sortDirection, sortable, field, displayName = i18nFilter()(props.field), isRightAligned } = props;
    const appData = chosenItems.getById(field);
    const appColor = appData?.Color;

    const header = (
        <AppHeaderWrapper>
            {appColor ? (
                <MarkerWrapper>
                    <Marker color={appColor} />
                </MarkerWrapper>
            ) : null}
            <span className={"headerCell-text u-truncate"}>{displayName}</span>
            {sortable ? <SortComponent sortDirection={sortDirection} /> : null}
        </AppHeaderWrapper>
    );

    return appData?.Tooltip ? (
        <HeaderWrapper isRightAligned={isRightAligned}>
            <AppTooltip
                app={appData.Tooltip.Title}
                appId={appData.Id}
                store={appData.Tooltip.AppStore}
                placement="top"
                getAssetsUrl={appData.Tooltip.Icon}
            >
                {header}
            </AppTooltip>
        </HeaderWrapper>
    ) : (
        header
    );
};

AppHeaderWithMarker.displayName = "AppHeaderWithMarker";
